import { PAYMENT_METHOD_INVOICE, PAYMENT_METHOD_STRIPE, PAYMENT_METHOD_VIPPS } from './PaymentMethods';
import { CREDITCARD_TEXT_KEY, INVOICE_TEXT_KEY, PAY_WITH_TEXT_KEY } from '../../i18n/project-i18n-model';
import I18nText from '../../i18n/I18nText';
import { VippsLogo } from '../../../components/button/vipps-button/VippsLogo';
import Image from '../../../components/image/Image';
import styles from './payment-methods.module.less';
import { formatMoneyKr } from '../../../utils';

export const paymentMethodLabel = (method) =>
    method === PAYMENT_METHOD_VIPPS ? (
        'Vipps'
    ) : method === PAYMENT_METHOD_STRIPE ? (
        <I18nText textKey={CREDITCARD_TEXT_KEY} />
    ) : (
        <I18nText textKey={INVOICE_TEXT_KEY} />
    );

export const paymentMethodTrackingLabel = (method) =>
    method === PAYMENT_METHOD_VIPPS
        ? 'Vipps'
        : method === PAYMENT_METHOD_STRIPE
          ? 'Stripe'
          : method === PAYMENT_METHOD_INVOICE
            ? 'Invoice'
            : 'unknown-payment-method';

export const paymentMethodTitle = (method) => {
    switch (method) {
        case PAYMENT_METHOD_STRIPE:
            return (
                <>
                    <I18nText textKey={PAY_WITH_TEXT_KEY} /> <I18nText textKey={CREDITCARD_TEXT_KEY} lowerCase />
                </>
            );
        case PAYMENT_METHOD_INVOICE:
            return (
                <>
                    <I18nText textKey={PAY_WITH_TEXT_KEY} /> <I18nText textKey={INVOICE_TEXT_KEY} lowerCase />
                </>
            );
        case PAYMENT_METHOD_VIPPS:
            return (
                <>
                    <I18nText textKey={PAY_WITH_TEXT_KEY} /> <VippsLogo aria-label="Vipps" />
                </>
            );
    }
};

export const paymentMethodCardIllustration = (method) => {
    switch (method) {
        case PAYMENT_METHOD_STRIPE:
            return (
                <span className={[styles.creditCards, styles.cardIllustrations].join(' ')}>
                    <Image src="visa.png" alt="Visa" className={styles.cardIllustrations} aria-hidden />{' '}
                    <Image src="mastercard.svg" alt="Mastercard" className={styles.cardIllustrations} aria-hidden />
                    <Image src="amex.png" alt="Amex" className={styles.cardIllustrations} aria-hidden />
                </span>
            );
        case PAYMENT_METHOD_VIPPS:
            return <Image src="vipps-card.svg" alt="Vipps" className={styles.cardIllustrations} aria-hidden />;
        case PAYMENT_METHOD_INVOICE:
            return null;
    }
};

export const validatePaymentAmount = ({
    method,
    amount,
    setAmountError,
    stripeMaxAmount,
    vippsMaxAmount,
    minAmount,
    maxAmount,
    rewards = [],
}) => {
    if (rewards.length > 0) {
        const rewardsTotal = rewards.reduce((acc, curr) => curr.price * curr.count + acc, 0);

        if (rewardsTotal && amount < rewardsTotal) {
            setAmountError({
                amount: `Beløpet må være ${formatMoneyKr(rewardsTotal)} eller høyere.`,
            });
            return false;
        }
    }
    if (!amount || (minAmount && amount < minAmount)) {
        setAmountError({
            amount: `Beløpet må være ${formatMoneyKr(minAmount)} eller høyere.`,
        });
        return false;
    } else if (maxAmount && amount > maxAmount) {
        setAmountError({
            amount: `Beløpet kan maksimalt være ${formatMoneyKr(maxAmount)}.`,
        });
        return false;
    }

    switch (method) {
        case PAYMENT_METHOD_STRIPE:
            if (amount > stripeMaxAmount) {
                setAmountError({
                    amount: `Maks beløp for betaling med Stripe er ${formatMoneyKr(
                        stripeMaxAmount
                    )}. Velg faktura som betalingsmåte, eller juster ned beløpet`,
                });
                return false;
            }
            break;
        case PAYMENT_METHOD_INVOICE:
            break;
        case PAYMENT_METHOD_VIPPS:
            if (amount > vippsMaxAmount) {
                setAmountError({
                    amount: `Maks beløp for betaling med Vipps er ${formatMoneyKr(vippsMaxAmount)}. Velg faktura ${
                        amount < stripeMaxAmount ? 'eller kort' : ''
                    } som betalingsmåte, eller juster ned beløpet`,
                });
                return false;
            }
            break;
    }
    setAmountError(null);
    return true;
};
